var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.554372 58.2447L31.8912 2.44991C33.413 -0.259598 37.3082 -0.274732 38.851 2.42286L70.7611 58.2176C72.2862 60.8843 70.3608 64.2035 67.2888 64.2035H4.04195C0.983793 64.2035 -0.943191 60.9111 0.554372 58.2447ZM38.2911 37.4611C38.2911 39.4006 36.7616 40.9785 34.8818 40.9785C33.002 40.9785 31.4728 39.4006 31.4728 37.4611V23.5348C31.4728 21.5953 33.002 20.0174 34.8818 20.0174C36.7616 20.0174 38.2911 21.5953 38.2911 23.5348V37.4611ZM38.3705 50.8367C38.3705 52.8213 36.8055 54.436 34.8822 54.436C32.9588 54.436 31.3938 52.8213 31.3938 50.8367C31.3938 48.8522 32.9588 47.2374 34.8822 47.2374C36.8055 47.2374 38.3705 48.8522 38.3705 50.8367Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4d51084628d78087b6b83ba2242110df.svg";
export { ForwardRef as ReactComponent };